import React from "react";
import { IconTrophy } from "../ui/icons";
import { useApiData } from "../../hooks/useApiData";
import { unwrapArray } from "../../utils/api";
import Button from "../ui/Button";
import Card from "../ui/Card";
import LoadingOverlay from "../ui/LoadingOverlay";
import RankedBars from "../ui/RankedBars";
import { ListSkeleton } from "../ui/Skeleton";
import { EmptyState, ErrorState } from "../ui/StateBlock";

/** Top 5 items: name, value, bar and piece count, in a single ranked list. */
export default function Top5ItemsChart({ startDate, endDate, warehouse, refreshKey, onRetry, onDetails }) {
  const hasRange = Boolean(startDate && endDate);

  const { data: raw, loading, error } = useApiData(
    hasRange ? `/top_items.php?od=${startDate}&do=${endDate}${warehouse ? `&warehouse=${warehouse}` : ""}` : null,
    refreshKey
  );
  const data = unwrapArray(raw);
  const rows = data.map((d) => ({ label: d.artikal, value: d.vrednost, meta: `${formatPieces(d.komada)} kom` }));

  return (
    <Card
      title="Top 5 artikala"
      icon={IconTrophy}
      action={
        onDetails && (
          <Button variant="ghost" size="sm" onClick={onDetails}>
            Detalji
          </Button>
        )
      }
    >
      {error && data.length === 0 ? (
        <ErrorState onRetry={onRetry} />
      ) : data.length === 0 && loading ? (
        <ListSkeleton rows={5} />
      ) : data.length === 0 ? (
        <EmptyState title="Nema prodaje u izabranom periodu" hint="Probaj drugi period ili magacin." />
      ) : (
        <LoadingOverlay loading={loading}>
          <RankedBars rows={rows} />
        </LoadingOverlay>
      )}
    </Card>
  );
}

function formatPieces(v) {
  const n = Number(v) || 0;
  return n.toLocaleString("sr-RS", { maximumFractionDigits: 2 });
}
